export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=603651db9402304409cdf27d28b2278e2d1dbfb0b8&name=getProductServerAction!'